<template>
    <div class="fill-height of-y d-flex flex-column">

        <div class="d-flex align-center justify-center fill-height flex-column" v-if="!selectedFarm">
            <v-icon x-large class="mb-4 grey--text">mdi-tractor-variant</v-icon>
            <span class="grey--text text-h6">Please select a farm to continue</span>
        </div>

        <template v-else-if="loading">
            <div class="d-flex fill-height align-center justify-center">
                <loader :size="36"></loader>
            </div>
        </template>

        <template v-else>
            <div class="flex-grow-0 pa-2 d-flex justify-space-between">
                <v-btn
                    :disabled="!data.length"
                    @click="exportReportData"
                    color="primary"
                    small
                    :loading="exportingData"
                >
                    Export
                </v-btn>
                <div class="flex-grow-1"></div>
                <div style="width: 30%">
                    <v-text-field
                        v-model="search"
                        prepend-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        class="pa-0 ma-0"
                    ></v-text-field>
                </div>
            </div>
            <div class="flex-grow-1 of-y">
                <v-data-table
                    :search="search"
                    dense
                    fixed-header
                    height="100%"
                    class="fill-height of-y"
                    hide-default-footer
                    :headers="headers"
                    :items="data"
                    :options="{itemsPerPage: data.length}"
                ></v-data-table>
            </div>
        </template>

    </div>
</template>

<script>
import { format } from 'date-fns';
import { mapGetters } from 'vuex';
import Loader from '../General/Loader/Loader';

export default {
    components: { Loader },
    props: {
        selectedFarm: Number,
        selectedDate: Date,
    },
    data() {
        return {
            search: null,
            headers: [
                { text: 'Farm',          value: 'farmName' },
                { text: 'Date',          value: 'dateStr' },
                { text: 'Team',          value: 'team' },
                { text: 'Block',         value: 'blockName' },
                { text: 'Variety',       value: 'varietyName' },
                { text: 'Piecework Type', value: 'pwType' },
                { text: 'Unit',          value: 'unitDescription' },
                { text: 'Total Units',   value: 'totalUnits' },
                { text: 'Employees',     value: 'employeeCount' },
                { text: 'Start',         value: 'startHourStr' },
                { text: 'End',           value: 'endHourStr' },
            ],
            data: [],
            exportingData: false,
            loading: false,
        };
    },
    mounted() {
        if (this.selectedFarm && this.selectedDate)
            this.getData();
    },
    watch: {
        selectedFarm(val) { if (val) this.getData(); },
        selectedDate(val) { if (val) this.getData(); },
    },
    methods: {
        async getData() {
            try {
                this.loading = true;
                this.data = await this.$newReq('POST', 'reports/piecework', {
                    farm: this.selectedFarm,
                    start: this.selectedDate,
                });
            } catch (e) {
                console.log(e);
                this.$snack.netWorkError();
            } finally {
                this.loading = false;
            }
        },
        exportReportData() {
            this.exportingData = true;
            this.$newReqDownloadFile(
                'POST',
                'reports/piecework/export',
                {
                    start: this.selectedDate,
                    farm: this.selectedFarm,
                    farmDescription: this.farm.description,
                },
                `${this.farm.description} Piecework Report ${format(this.selectedDate, 'MMMM yyyy')}.xlsx`
            )
                .catch(e => {
                    console.log(e);
                    this.$snack.netWorkError();
                })
                .finally(() => { this.exportingData = false; });
        },
    },
    computed: {
        ...mapGetters(['farmsRef']),
        farm() {
            return this.selectedFarm ? this.farmsRef[this.selectedFarm] : null;
        },
    },
};
</script>

<style scoped>
</style>
